import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import {
  ICustomerProfileState,
  setPetDetails,
  setPetId,
} from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { useEffect } from "react";
import useRouteInfo from "../../useRouteInfo";
import { useRouter } from "../../useRouter";

export const useSetPetDetails = (directPetId?: string) => {
  const { getRouteKey } = useRouter();
  const dispatch = useAppDispatch();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { customerPets } = routeState.state as ICustomerProfileState;

  const getSelectedPet = (passedPetId: string) => {
    return customerPets.filter((cp) => cp.id === passedPetId)[0];
  };

  const setPetData = (otherPetId: string) => {
    if (otherPetId) {
      const selectedPet = getSelectedPet(otherPetId);
      dispatch(
        setPetDetails({
          petDetails: selectedPet,
        }),
      );
      dispatch(
        setPetId({
          petId: otherPetId,
        }),
      );
    }
  };

  useEffect(() => {
    if (customerPets?.length > 0) {
      if (directPetId) {
        const selectedPet = getSelectedPet(directPetId);
        dispatch(
          setPetDetails({
            petDetails: selectedPet,
          }),
        );
        dispatch(
          setPetId({
            petId: directPetId,
          }),
        );
      }
    }
  }, [customerPets?.length]);

  return setPetData;
};
